import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

function AppBrandingBand() {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.3 });

  return (
    <div className="brandingBand">
      <motion.div
        ref={ref}
        initial={{ opacity: 0, scale: 0.93 }}
        animate={inView ? { opacity: 1, scale: 1 } : {}}
        transition={{ duration: 0.55, ease: "easeOut" }}
      >
        <img
          src="/sections/branding/saxemble-wordmark.png"
          alt="sax'emble – [sax(ophon) + (ens)emble]"
          className="wordmark"
          loading="lazy"
        />
        <p className="formula">[sax(ophon) + (ens)emble]</p>
        <p className="tagline">Saxophonorchester Kloster Schöntal</p>
      </motion.div>
    </div>
  );
}

export default AppBrandingBand;
